const strict = true;

const state = {
  successDialog: {
    active: false,
    title: "",
    message: "",
    btnText: "",
    btnAction: null
  }
};

const getters = {
  successDialog: state => state.successDialog
};

const mutations = {
  reset(state) {
    state.successDialog = {
      active: false,
      title: "",
      message: "",
      btnText: "",
      btnAction: null
    };
  },
  openSuccessDialog(state, { title, message, btnText, btnAction }) {
    state.successDialog = {
      active: true,
      title,
      message,
      btnText,
      btnAction
    };
  }
};

const actions = {};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
